<template>
  <div>
    <!--  Сумма фактически выплаченных дивидендов  -->
    <div class="row myrow content-mb-42_"
         v-if="$parent.$parent.rerender &&
         $parent.project.DIVIDENDS.items.length > 0">
      <p class="content-s-2-label"
         v-if="!isMainPunct"
         style="text-align: left; display: flex;
         align-items: center; gap: 10px">
        <label>Сумма фактически выплаченных дивидендов</label>
        <VDropdown trigger="click" placement="bottom" popperClass="custom-popper">
        <a class="info-holder-icon" />
        <template #popper>
          <span
            v-if="
              $parent.project.UF_HELP.FIELDS &&
                $parent.project.UF_HELP.FIELDS.STEP2 &&
                $parent.project.UF_HELP.FIELDS.STEP2.DIVIDENDS
            "
          >
            {{ $parent.project.UF_HELP.FIELDS.STEP2.DOP_PLACE_ADD }}
          </span>
          <span v-else>
            Укажите сумму дивидендов, выплаченных Заявителем в указанные периоды
          </span>
        </template>
      </VDropdown>
      </p>
      <div class="col-xs-12 mycol">
        <table
          class="c-indicator content-mb-18 table-indicators-min-cell"
          style="max-width: 1000px;"
        >
          <thead>
          <tr class="head-financlial-block">
            <th>Последний завершенный год<br /> {{ project.DIVIDENDS.items[0].UF_LAST_YEAR }}, тыс. руб.</th>
            <th>Завершенные периоды текущего года
              <template v-if="project.DIVIDENDS.items[0].UF_PERIOD_NAME != 'нет'">
                <br />{{ project.DIVIDENDS.items[0].UF_PERIOD_NAME }}, тыс. руб.
              </template>
            </th>
            <th class="cnt">Итого, тыс. руб.</th>
            <th class="cnt">Сумма займа, тыс. руб.</th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in project.DIVIDENDS.items"
            v-bind:value="item.UF_DIVIDEND_PERIOD_SP_ID"
            v-bind:key="item.UF_DIVIDEND_PERIOD_SP_ID"
          >
            <td>
              <vue-numeric
                separator="space"
                v-bind:key="'year_'+item.UF_DIVIDEND_PERIOD_SP_ID"
                type="text"
                class="i-main-style"
                :value="item.UF_LAST_YEAR_SUM || 0"
                @input="val => item.UF_LAST_YEAR_SUM = val"
                :disabled="$parent.$parent.projectDisabled"
              />
            </td>
            <td>
              <vue-numeric
                v-if="project.DIVIDENDS.items[0].UF_PERIOD_NAME != 'нет'"
                separator="space"
                v-bind:key="'month_'+item.UF_DIVIDEND_PERIOD_SP_ID"
                type="text"
                class="i-main-style"
                :value="item.UF_PERIOD_SUM || 0"
                @input="val => item.UF_PERIOD_SUM = val"
                :disabled="$parent.$parent.projectDisabled"
              />
              <span v-else>Нет</span>
            </td>
            <td class="cnt"><b>{{ item.UF_LAST_YEAR_SUM + item.UF_PERIOD_SUM | toCurrency }}</b></td>
            <td class="cnt"
                v-if="$parent.project.UF_SUM_REQUEST > 0">
              <span
                :class="(calculateProcentZaim(item.UF_LAST_YEAR_SUM, item.UF_PERIOD_SUM) <= 500)?'green':'red'">
              <b>
                {{ calculateProcentZaim(item.UF_LAST_YEAR_SUM, item.UF_PERIOD_SUM) }}
              </b> %
              </span>
              <span v-if="calculateProcentZaim(item.UF_LAST_YEAR_SUM, item.UF_PERIOD_SUM) > 500"
                    class="red"
              >
                <br />Сумма выплаченных дивидендов превышает 500% от суммы займа. Дальнейшее рассмотрение заявки невозможно
              </span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
//import Vue from "vue";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORIES } from "@/store/actions.type";

export default {
  name: "FinancialIndicator",
  props: ["isMainPunct"],
  data() {
    return {
      isViewSpecialCompanyProjectSelect: false,
      isViewReestrOPKSelect: false,
      idProfit: 0,
      idAverage: 0,
      idProfitability: 0,
      idVurychka: 0,
      isAllNull: true
    };
  },
  methods: {
    isNumber: function(evt, indicator, val) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      if (indicator.IS_PROCENT === 0 && charCode === 46) {
        evt.preventDefault();
        return false;
      }
      if (
        indicator.IS_PROCENT === 1 &&
        charCode === 46 &&
        typeof val.indexOf !== "undefined" &&
        val.indexOf(".") !== -1
      ) {
        evt.preventDefault();
        return false;
      }
      if (indicator.IS_PROCENT === 1 && charCode === 46) {
        return true;
      }
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    in_array(idFind, a) {
      return a.filter(function(item) {
        return item == idFind;
      }).length
        ? true
        : false;
    },
    calculateProcentZaim(last_year, period) {
      if (this.$parent.project.UF_SUM_REQUEST > 0) {
        let procent =  parseFloat(((last_year + period) / this.$parent.project.UF_SUM_REQUEST) * 100).toFixed(2);
        return procent;
      } else {
        return 0;
      }
    }
  },
  computed: {
    ...mapGetters(["directory", "project"]),
  },
};
</script>

<style scoped></style>
